/**
 * service-reporting-ml client (public surface).
 *
 * Endpoints used by the operator console (slice scope):
 *   GET   /v1/reporting-ml/fraud-alerts/summary?from=&to=
 *   GET   /v1/reporting-ml/forecast/transactions?days=
 *   GET   /v1/reporting-ml/risk-score/summary
 *
 * Internal endpoints (POST /v1/reporting-ml/forecasts, POST /v1/reporting-ml/fraud-scores,
 * POST /v1/reporting-ml/sentiment/score) live in the analyst console — not here.
 */
import { env } from '../env';

import { request } from './client';

const baseUrl = (): string => env.serviceReportingMlBaseUrl;

export interface FraudAlertSummaryResponse {
  // eslint-disable-next-line upmp/no-number-money -- row count
  readonly total: number;
   
  readonly criticalCount: number;
   
  readonly openCount: number;
  readonly byKind: Readonly<Record<string, number>>;
}

export interface FraudAlertSummaryQuery {
  /** YYYY-MM-DD. */
  readonly from?: string;
  /** YYYY-MM-DD. */
  readonly to?: string;
}

export async function getFraudAlertSummary(
  q: FraudAlertSummaryQuery = {},
): Promise<FraudAlertSummaryResponse> {
  return request<FraudAlertSummaryResponse>(
    baseUrl(),
    '/v1/reporting-ml/fraud-alerts/summary',
    { method: 'GET', query: { from: q.from, to: q.to } },
  );
}

export interface ForecastDay {
  readonly date: string;
   
  readonly projectedTxnCount: number;
   
  readonly projectedRevenueMinor: number;
   
  readonly confidenceLow: number;
   
  readonly confidenceHigh: number;
}

export interface ForecastTransactionsResponse {
  readonly forecast: readonly ForecastDay[];
  readonly adapter: string;
}

export async function getForecastTransactions(
  days = 30,
): Promise<ForecastTransactionsResponse> {
  return request<ForecastTransactionsResponse>(
    baseUrl(),
    '/v1/reporting-ml/forecast/transactions',
    { method: 'GET', query: { days } },
  );
}

export interface RiskScoreSummaryResponse {
   
  readonly highRiskCount: number;
   
  readonly mediumRiskCount: number;
   
  readonly lowRiskCount: number;
}

export async function getRiskScoreSummary(): Promise<RiskScoreSummaryResponse> {
  return request<RiskScoreSummaryResponse>(
    baseUrl(),
    '/v1/reporting-ml/risk-score/summary',
    { method: 'GET' },
  );
}
